// Copyright (c) 2021 WiseTime. All rights reserved.

import { Timeline, TimeRow } from "../../generated/wisetime/user/timeline/v4/timeline_pb"
import { debug } from "../../app/logging"
import produce from "immer"
import { isDevelopmentEnv, isTestEnv } from "../../app/config"

export const patchIconUrl = (iconUrl: string): string =>
  (isDevelopmentEnv() || isTestEnv()) ? `https://wisetime.ninja${iconUrl}` : iconUrl
// Convert the timeline's relative URLs to absolute ones, for development purposes.
// In development, the timeline runs at http://localhost:3000/timeline.
// Some URLs, e.g. icon URLs are relative and will not work with localhost.
// URLs are only patched for non-production environments.
const patchTimeRowIconURL = (timeRow: TimeRow.AsObject): void => {
  timeRow.iconUrl = patchIconUrl(timeRow.iconUrl)
}

export const patchDevelopmentUrls = (timeline: Timeline.AsObject): Timeline.AsObject => {
  if (isDevelopmentEnv() || isTestEnv()) {
    debug("Patching icon URLs to use absolute staging path")
    return produce(timeline, newTimeline => {
      newTimeline.timeRowsInRangeList.forEach(patchTimeRowIconURL)
    })
  }

  return timeline
}

export const patchDevelopmentUrl = (timeRow: TimeRow.AsObject): TimeRow.AsObject => {
  if (isDevelopmentEnv() || isTestEnv()) {
    console.log("Patching icon URL to use absolute staging path")
    return produce(timeRow, newTimeRow => patchTimeRowIconURL(newTimeRow))
  }

  return timeRow
}
